<template>
    <v-layout>
      xx
    </v-layout>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Logout.vue',
  components: {},
  data () {
    return {
    }
  },
  mounted () {
    Vue.prototype.$api.sendGetRequest('Logout.php');
    Vue.prototype.$api.resetCredentials(this)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Login/Logout.vue